/* ==========================================================================
   Brow BFF — landing page behaviour (templates/page.brow-bff.json).
   Loaded by layout/landing.liquid for this template only.

   Every add to bag posts to /cart/add.js: Rebuy's Smart Cart opens off that
   request, and /cart itself redirects home on this store, so a cart
   permalink or a native form submit would lose the shopper.
   ========================================================================== */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function strings() {
    var el = $('[data-bbff-strings]');
    try { return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; }
  }

  function say(text) {
    var live = $('[data-bbff-live]');
    if (!live || !text) return;
    live.textContent = '';
    window.setTimeout(function () { live.textContent = text; }, 50);
  }

  // The store's money format, e.g. "${{amount}}", with ".00" dropped the way
  // Liquid's money_without_trailing_zeros drops it.
  function money(cents, format) {
    var amount = (cents / 100).toFixed(2);
    var noDecimals = String(Math.round(cents / 100));
    var out = (format || '${{amount}}')
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, amount);
    return out.replace(/([.,])00(?!\d)/, '');
  }

  function fill(template, values) {
    return String(template || '').replace(/\{(\w+)\}/g, function (m, k) { return values[k] != null ? values[k] : m; });
  }

  function bumpCartCount() {
    fetch(root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-bbff-cart-count], [data-js-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      })
      .catch(function () { /* the count is decoration; the add already worked */ });
  }

  function addToBag(items, trigger, itemLabel) {
    var s = strings();
    if (trigger) trigger.classList.add('is-loading');
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        bumpCartCount();
        // Rebuy opens itself off the /cart/add.js request. Only nudge it once
        // it is ready: show() while it is initialising wedges it.
        var sc = window.Rebuy && window.Rebuy.SmartCart;
        if (sc && sc.status === 'ready' && typeof sc.show === 'function') sc.show();
        say(fill(s.added || 'Added {item} to your bag.', { item: itemLabel }));
      })
      .catch(function () {
        say(s.addFailed || 'Sorry, that could not be added to your bag. Please try again.');
      })
      .then(function () { if (trigger) trigger.classList.remove('is-loading'); });
  }

  // ── Hero: carousel + shade picker ─────────────────────────────────────────
  function initHero() {
    var form = $('[data-bbff-shop]');
    var carousel = $('[data-bbff-carousel]');
    if (!form || form.__bbff) return;
    form.__bbff = true;

    var format = form.getAttribute('data-money-format');
    var slides = carousel ? $$('[data-bbff-slide]', carousel) : [];
    var dotsWrap = carousel && $('[data-bbff-dots]', carousel);
    var chip = carousel && $('[data-bbff-slide-label]', carousel);
    var status = carousel && $('[data-bbff-slide-status]', carousel);
    var current = [];
    var index = 0;

    function checked() { return $('input[name="bbff-shade"]:checked', form); }

    function showSlide(i, announce) {
      if (!current.length) return;
      index = (i + current.length) % current.length;
      slides.forEach(function (s) { s.classList.remove('is-active'); });
      var active = current[index];
      active.classList.add('is-active');
      // Lazy images inside a hidden slide are only fetched once shown.
      var img = active.querySelector('img');
      if (img) img.loading = 'eager';
      if (chip) chip.textContent = active.getAttribute('data-label') || '';
      $$('.bbff-hero__dot', dotsWrap).forEach(function (d, n) { d.setAttribute('aria-current', n === index ? 'true' : 'false'); });
      if (announce && status) status.textContent = (index + 1) + ' / ' + current.length + ': ' + (active.getAttribute('data-label') || '');
    }

    function buildSlides(variantId) {
      current = slides.filter(function (s) {
        var v = s.getAttribute('data-bbff-slide');
        return v === String(variantId) || v === 'all';
      });
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      current.forEach(function (s, n) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'bbff-hero__dot';
        b.setAttribute('aria-label', s.getAttribute('data-label') || String(n + 1));
        b.appendChild(document.createElement('span'));
        b.addEventListener('click', function () { showSlide(n, true); });
        dotsWrap.appendChild(b);
      });
    }

    function render() {
      var input = checked();
      if (!input) return;
      var price = parseInt(input.getAttribute('data-price'), 10) || 0;
      var compare = parseInt(input.getAttribute('data-compare'), 10) || 0;
      var soldOut = input.hasAttribute('data-sold-out');
      $('[data-bbff-shade-name]', form).textContent = input.getAttribute('data-name');
      $('[data-bbff-shade-desc]', form).textContent = input.getAttribute('data-desc') || '';
      $('[data-bbff-now]', form).textContent = money(price, format);
      var was = $('[data-bbff-was]', form);
      was.hidden = !(compare > price);
      if (compare > price) was.textContent = money(compare, format);
      var cta = $('[data-bbff-cta]', form);
      cta.disabled = soldOut;
      cta.textContent = soldOut ? form.getAttribute('data-sold-out') : fill(form.getAttribute('data-cta'), { price: money(price, format) });
      buildSlides(input.value);
      showSlide(0, false);
    }

    form.addEventListener('change', function (e) {
      if (!e.target || e.target.name !== 'bbff-shade') return;
      // The squish answers a tap only, never the default shade on load.
      form.classList.add('is-picked');
      render();
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = checked();
      if (!input || input.hasAttribute('data-sold-out')) return;
      addToBag([{ id: parseInt(input.value, 10), quantity: 1 }], $('[data-bbff-cta]', form), 'Brow BFF in ' + input.getAttribute('data-name'));
    });

    if (carousel) {
      $('[data-bbff-prev]', carousel).addEventListener('click', function () { showSlide(index - 1, true); });
      $('[data-bbff-next]', carousel).addEventListener('click', function () { showSlide(index + 1, true); });
      carousel.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); showSlide(index - 1, true); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); showSlide(index + 1, true); }
      });
    }
    render();

    // Violet's brow pick (read from the brows in the selfie) selects the
    // shade here: live when she matches, and on load from the sitewide record
    // a returning shopper already has. A sold-out pick is left alone.
    function pickBrow(name) {
      if (!name) return;
      var input = $$('input[name="bbff-shade"]', form).filter(function (i) { return i.getAttribute('data-name') === name; })[0];
      if (!input || input.checked || input.hasAttribute('data-sold-out')) return;
      input.checked = true;
      render();
    }
    document.addEventListener('subtl:violet:matched', function (e) {
      pickBrow(e.detail && e.detail.picks && e.detail.picks.brow);
    });
    try {
      var rec = JSON.parse(window.localStorage.getItem('subtl:shade') || 'null');
      if (rec && rec.picks) pickBrow(rec.picks.brow);
    } catch (e) { /* private mode */ }
  }

  // ── Add-on shade dropdowns (button + listbox, with swatches) ───────────
  // A listbox rather than a <select> so each shade shows its swatch. Keyboard
  // follows the ARIA listbox pattern: arrows / Home / End move, Enter or
  // Space picks, Escape and Tab close. Picking a shade also ticks its add-on.
  function initDrops() {
    $$('[data-bbff-drop]').forEach(function (drop) {
      if (drop.__bbff) return;
      drop.__bbff = true;
      var btn = $('[data-bbff-drop-btn]', drop);
      var list = $('[data-bbff-drop-list]', drop);
      var input = $('[data-bbff-addon]', drop);
      var opts = $$('[role="option"]', list);
      var active = -1;

      function selectedIndex() { return Math.max(0, opts.findIndex(function (o) { return o.getAttribute('aria-selected') === 'true'; })); }
      function setActive(i) {
        active = (i + opts.length) % opts.length;
        opts.forEach(function (o, n) { o.classList.toggle('is-active', n === active); });
        list.setAttribute('aria-activedescendant', opts[active].id);
        opts[active].scrollIntoView({ block: 'nearest' });
      }
      function open() {
        $$('[data-bbff-drop-list]').forEach(function (l) { if (l !== list && !l.hidden) l.__bbffClose(); });
        list.hidden = false;
        btn.setAttribute('aria-expanded', 'true');
        setActive(selectedIndex());
        list.focus();
      }
      function close(refocus) {
        if (list.hidden) return;
        list.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
        list.removeAttribute('aria-activedescendant');
        if (refocus) btn.focus();
      }
      list.__bbffClose = function () { close(false); };
      function pick(i) {
        var o = opts[i];
        opts.forEach(function (x) { x.setAttribute('aria-selected', x === o ? 'true' : 'false'); });
        input.value = o.getAttribute('data-value');
        input.setAttribute('data-price', o.getAttribute('data-price'));
        $('[data-bbff-drop-val]', btn).textContent = o.getAttribute('data-name');
        var sw = $('.bbff-drop__sw', o);
        $('[data-bbff-drop-sw]', btn).style.setProperty('--sw', sw ? sw.style.getPropertyValue('--sw') : '');
        var row = drop.closest('.bbff-look__addon');
        var box = row && $('[data-bbff-addon-on]', row);
        if (box) box.checked = true;
        close(true);
        drop.dispatchEvent(new Event('change', { bubbles: true }));
      }

      btn.addEventListener('click', function () { if (list.hidden) open(); else close(true); });
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); open(); }
      });
      list.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') { e.preventDefault(); setActive(active + 1); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
        else if (e.key === 'Home') { e.preventDefault(); setActive(0); }
        else if (e.key === 'End') { e.preventDefault(); setActive(opts.length - 1); }
        else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(active); }
        else if (e.key === 'Escape') { e.preventDefault(); close(true); }
        else if (e.key === 'Tab') { close(false); }
      });
      opts.forEach(function (o, i) {
        o.addEventListener('click', function () { pick(i); });
        o.addEventListener('mousemove', function () { if (active !== i) setActive(i); });
      });
      document.addEventListener('pointerdown', function (e) { if (!drop.contains(e.target)) close(false); });
    });
  }

  // ── Scroll reveals ───────────────────────────────────────────────────────
  // The header section adds .bbff-fx to <html> before the page parses (never
  // with reduced motion); the stylesheet hides [data-reveal] only while that
  // class is there. This confirms it and plays each reveal once on screen.
  var revealIO = null;
  function splitWords(h) {
    if (!h || h.__bbffSplit) return;
    h.__bbffSplit = true;
    // A heading that wraps an icon and a span (Violet's) splits only the span.
    var inner = h.querySelector(':scope > span');
    var target = inner && !h.querySelector(':scope > br') ? inner : h;
    var label = target.textContent.replace(/\s+/g, ' ').trim();
    var nodes = Array.prototype.slice.call(target.childNodes);
    var i = 0;
    target.textContent = '';
    nodes.forEach(function (nd) {
      if (nd.nodeType !== 3) { target.appendChild(nd); return; }
      nd.textContent.split(/(\s+)/).forEach(function (w) {
        if (!w) return;
        if (/^\s+$/.test(w)) { target.appendChild(document.createTextNode(' ')); return; }
        var outer = document.createElement('span');
        outer.className = 'bbff-w';
        outer.setAttribute('aria-hidden', 'true');
        var word = document.createElement('span');
        word.textContent = w;
        word.style.setProperty('--wd', (i++ * 0.09).toFixed(2) + 's');
        outer.appendChild(word);
        target.appendChild(outer);
      });
    });
    // The words are hidden from screen readers; they hear the line whole.
    var sr = document.createElement('span');
    sr.className = 'bbff__sr-only';
    sr.textContent = label;
    target.appendChild(sr);
  }
  function prepReveal(el) {
    var fx = el.getAttribute('data-fx');
    if (fx === 'words') {
      var h = el.matches('h1, h2, h3, blockquote') ? el : el.querySelector('h2, h3, blockquote');
      splitWords(h);
      var k = 0;
      Array.prototype.forEach.call(el.children, function (c) {
        if (h && (c === h || c.contains(h))) { c.classList.add('bbff-fx-keep'); return; }
        c.style.setProperty('--k', k++);
      });
    } else if (fx === 'stagger') {
      Array.prototype.forEach.call(el.children, function (c, n) { c.style.setProperty('--k', n); });
    }
  }
  function playReveal(el) {
    el.classList.add('is-in');
    // Once every child has arrived, hand transitions back to their own rules.
    var n = el.children.length;
    var ms = (parseFloat(getComputedStyle(el).getPropertyValue('--d')) || 0) * 1000 + 1000 + n * 120 + (el.getAttribute('data-fx') === 'words' ? 800 : 0);
    window.setTimeout(function () { el.classList.add('is-settled'); }, ms);
  }
  function initReveals() {
    var root = document.documentElement;
    if (!root.classList.contains('bbff-fx')) return;
    root.classList.add('bbff-fx-ready');
    if (!revealIO) {
      revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          revealIO.unobserve(e.target);
          playReveal(e.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    }
    $$('[data-reveal]').forEach(function (el) {
      if (el.__bbffReveal) return;
      el.__bbffReveal = true;
      prepReveal(el);
      revealIO.observe(el);
    });
  }

  // ── 3 steps: one auto-played pass, stopped for good by any interaction ───
  function initSteps() {
    $$('[data-bbff-steps]').forEach(function (row) {
      if (row.__bbff) return;
      row.__bbff = true;
      var cards = $$('[data-bbff-step]', row);
      var ms = parseInt(row.getAttribute('data-interval'), 10) || 4000;
      var timer = null;
      var auto = !reduceMotion && cards.length > 1;
      row.style.setProperty('--bbff-step-ms', ms + 'ms');

      function open(n) {
        cards.forEach(function (c, i) {
          c.classList.toggle('is-open', i === n);
          c.classList.toggle('is-done', i < n);
          c.setAttribute('aria-expanded', i === n ? 'true' : 'false');
        });
      }
      function stop() {
        auto = false;
        row.classList.remove('is-auto');
        if (timer) window.clearTimeout(timer);
        timer = null;
      }
      function tick(n) {
        open(n);
        // One pass through the steps, then it rests on the last one.
        if (n >= cards.length - 1) { timer = window.setTimeout(stop, ms); return; }
        timer = window.setTimeout(function () { if (auto) tick(n + 1); }, ms);
      }

      cards.forEach(function (c, i) {
        c.addEventListener('click', function () { stop(); open(i); });
      });
      row.addEventListener('focusin', stop);

      if (!auto) return;
      if (!('IntersectionObserver' in window)) { row.classList.add('is-auto'); tick(0); return; }
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        if (!auto) return;
        row.classList.add('is-auto');
        tick(0);
      }, { threshold: 0.5 });
      io.observe(row);
    });
  }

  // ── Looks: pencil + ticked add-ons, one request ──────────────────────────
  function initLooks() {
    $$('[data-bbff-look]').forEach(function (form) {
      if (form.__bbff) return;
      form.__bbff = true;
      var format = form.getAttribute('data-money-format');
      var cta = $('[data-bbff-look-cta]', form);
      var pencilPrice = parseInt(form.getAttribute('data-pencil-price'), 10) || 0;
      var pencilName = form.getAttribute('data-pencil-name');

      function addons() {
        return $$('.bbff-look__addon', form).map(function (row) {
          var input = $('[data-bbff-addon]', row);
          return {
            on: $('[data-bbff-addon-on]', row).checked,
            id: input ? parseInt(input.value, 10) : 0,
            price: input ? parseInt(input.getAttribute('data-price'), 10) || 0 : 0,
            priceEl: $('[data-bbff-addon-price]', row)
          };
        });
      }
      function render() {
        if (cta.disabled) return;
        var total = pencilPrice;
        var extra = 0;
        addons().forEach(function (a) {
          if (a.priceEl) a.priceEl.textContent = money(a.price, format);
          if (a.on && a.id) { total += a.price; extra += 1; }
        });
        cta.textContent = extra
          ? fill(form.getAttribute('data-cta-bundle'), { price: money(total, format) })
          : fill(form.getAttribute('data-cta-single'), { shade: pencilName, price: money(total, format) });
      }
      form.addEventListener('change', render);
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (cta.disabled) return;
        var items = [{ id: parseInt(form.getAttribute('data-pencil'), 10), quantity: 1 }];
        addons().forEach(function (a) { if (a.on && a.id) items.push({ id: a.id, quantity: 1 }); });
        addToBag(items, cta, items.length > 1 ? 'the look' : 'Brow BFF in ' + pencilName);
      });
      render();
    });

    // Look videos load only as they near the viewport (their sources carry
    // data-src), then play muted on a loop. The pause button is WCAG 2.2.2;
    // reduced motion loads them but leaves them paused on the first frame.
    $$('[data-bbff-video]').forEach(function (video) {
      if (video.__bbff) return;
      video.__bbff = true;
      var btn = video.parentNode.querySelector('[data-bbff-video-toggle]');
      var pauseLabel = btn ? btn.getAttribute('aria-label') : '';
      function sync() {
        if (!btn) return;
        btn.setAttribute('aria-pressed', video.paused ? 'true' : 'false');
        btn.setAttribute('aria-label', video.paused ? pauseLabel.replace(/^Pause/, 'Play') : pauseLabel);
      }
      function start() {
        $$('source[data-src]', video).forEach(function (src) { src.src = src.getAttribute('data-src'); src.removeAttribute('data-src'); });
        video.preload = 'auto';
        // The autoplay flag as well as play(): a tab opened in the background
        // refuses play(), and the flag starts it once the tab is shown.
        video.autoplay = !reduceMotion;
        video.load();
        if (!reduceMotion) { var pr = video.play(); if (pr && pr.catch) pr.catch(function () { /* autoplay refused; the button still plays it */ }); }
      }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (!entries[0].isIntersecting) return;
          io.disconnect();
          start();
        }, { rootMargin: '800px 0px' });
        io.observe(video);
      } else {
        start();
      }
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      if (btn) btn.addEventListener('click', function () { if (video.paused) video.play(); else video.pause(); });
      sync();
    });
  }

  // ── Before / after tabs ──────────────────────────────────────────────────
  function initBeforeAfter() {
    $$('[data-bbff-ba]').forEach(function (list) {
      if (list.__bbff) return;
      list.__bbff = true;
      var tabs = $$('[role="tab"]', list);
      function select(tab, focus) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        if (focus) tab.focus();
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t, false); });
        t.addEventListener('mouseenter', function () { select(t, false); });
        t.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = (i + 1) % tabs.length;
          else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = (i - 1 + tabs.length) % tabs.length;
          else if (e.key === 'Home') n = 0;
          else if (e.key === 'End') n = tabs.length - 1;
          if (n === null) return;
          e.preventDefault();
          select(tabs[n], true);
        });
      });
    });
    // The divider sweeps in the first time the band is on screen.
    $$('.bbff-ba').forEach(function (band) {
      if (band.__bbffSeen || !('IntersectionObserver' in window)) return;
      band.__bbffSeen = true;
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        band.classList.add('is-inview');
        io.disconnect();
      }, { threshold: 0.4 });
      io.observe(band);
    });
  }

  // ── Reviews: collapsed until asked; every rating link opens them ─────────
  function setReviews(open) {
    var panel = $('[data-bbff-reviews-panel]');
    var toggle = $('[data-bbff-reviews-toggle]');
    if (!panel || !toggle) return;
    panel.hidden = !open;
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    toggle.textContent = toggle.getAttribute(open ? 'data-hide' : 'data-read');
  }

  function scrollToEl(el) {
    el.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  }

  var bound = false;
  function bindDocument() {
    if (bound) return;
    bound = true;
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-bbff-reviews-toggle], [data-bbff-open-reviews], [data-bbff-to-shop]');
      if (!t) return;
      if (t.hasAttribute('data-bbff-reviews-toggle')) {
        setReviews(t.getAttribute('aria-expanded') !== 'true');
        return;
      }
      if (t.hasAttribute('data-bbff-open-reviews')) {
        var reviews = document.getElementById('reviews');
        if (!reviews) return;
        e.preventDefault();
        setReviews(true);
        scrollToEl(reviews);
        var toggle = $('[data-bbff-reviews-toggle]');
        if (toggle) toggle.focus({ preventScroll: true });
        return;
      }
      // "Pick my shade" / "See all five shades": to the picker, focus on the
      // shade that is picked so keyboard users land where they can act.
      var shop = document.getElementById('shop');
      if (!shop) return;
      e.preventDefault();
      scrollToEl(shop);
      var picked = $('input[name="bbff-shade"]:checked', shop);
      if (picked) picked.focus({ preventScroll: true });
    });
    if (window.location.hash === '#reviews') setReviews(true);
  }

  function boot() {
    initReveals();
    bindDocument();
    initHero();
    initSteps();
    initDrops();
    initLooks();
    initBeforeAfter();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Theme editor: a re-rendered section brings fresh markup to bind.
  document.addEventListener('shopify:section:load', boot);
})();
